import { z } from 'zod';
import { Invoice } from './invoice.entity';
import { FromSchema, ZodDate } from '@40seas/entities/common';

export const MarkAsPaidSchema = z.object({
    paymentDate: ZodDate,
    amount: z.number().min(0),
    receivingAccount: z.string().nullish(),
    note: z
        .string()
        .max(250, {
            message: 'Note must be less than 250 characters',
        })
        .nullish(),
});

export const getMarkAsPaidSchema = (invoice: Invoice) => {
    return z.object({
        paymentDate: z.date(),
        amount: z
            .number()
            .min(0)
            .max(invoice.total || invoice.amount),
        receivingAccount: z.string(),
        note: z
            .string()
            .max(250, {
                message: 'Note must be less than 250 characters',
            })
            .nullish(),
    });
};

export class MarkAsPaidDto extends FromSchema(MarkAsPaidSchema) {
    amount: number;
    note?: string;
    paymentDate: Date;
    receivingAccount?: string;
}
